import { render } from "./MedicalHeartScene.vue?vue&type=template&id=79918940&scoped=true"
import script from "./MedicalHeartScene.vue?vue&type=script&lang=js"
export * from "./MedicalHeartScene.vue?vue&type=script&lang=js"

import "./MedicalHeartScene.vue?vue&type=style&index=0&id=79918940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79918940"]])

export default __exports__